export class ProjectedImageData {
    img: ProductImage;
    colorCode?: string;
    constructor(img, code?) {
        this.img = img;
        this.colorCode = code;
    }
}
export class NewProductData {
  id: number;
  name: string;
  primaryImage: ProductImage;
  secondaryImage: ProductImage;
  width ?: string;
  weight ?: string;
  components: string [];
  colorDatas?: ColorData [];
  aditionalImages: ProductImage [];
  textilKresz ?: string [];
  relatedCategory ?: string;
}

export class ProductImage {
  s: string;
  m: string;
  l: string;

  constructor(s, m, l) {
    this.s = s;
    this.m = m;
    this.l = l;
  }
}
export class ColorData {
  id: number;
  fileName: string;
  colorCode: string;
  colorImage: ProductImage;

  constructor(id, colorCode, colorImage, fileName) {
    this.id = id;
    this.colorCode = colorCode;
    this.colorImage = colorImage;
    this.fileName = fileName;
  }
}
